import {ofType} from "redux-observable";
import * as giustificativiActionsType from "../../actions/actionsTypes/giustificativiActionType";
import {catchError, map, switchMap, withLatestFrom} from "rxjs/operators";
import {asyncScheduler, forkJoin, of, scheduled} from "rxjs";
import {fromPromise} from "rxjs/internal/observable/innerFrom";
import new_axios_instance from "../../axios_instance";
import {ENUM_TIMBRATURE} from "../../costanti";
import {createMessageRequestException} from "../../fanctionUtility";
import {giustificativiActions, individuoActions, loadingOverlayActions, notifsActions} from "../../actions";

export const giustificativiManuali = (actions$, state$) =>
    actions$.pipe(
        ofType(
            giustificativiActionsType.ADD_GIUSTIFICATIVO_ACTION
        ),
        switchMap(({payload}) =>
            forkJoin(payload.map(dati =>
                    fromPromise(new_axios_instance.post(`/v1/giustificativo/inserisci`, dati))
                        .pipe(
                            map(({data}) => ({
                                ...data,
                                isError: false
                            })),
                            catchError(err => of({
                                    [dati.idAnagrafica]: createMessageRequestException(err),
                                    isError: true
                                })
                            )
                        )
                )
            )
        ),
        withLatestFrom(state$),
        switchMap(([resp, state]) => {
            const actions = [], messageErrorTimbrature = [];
            const target = state.individui.individui;

            resp.filter(data => data.isError)
                .forEach(data => {
                    const individuo = target.find(x => x.idAnagrafica === Object.keys(data)[0]);
                    messageErrorTimbrature.push(`${individuo.cognome} ${individuo.nome}: ${data[Object.keys(data)[0]]}`);
                });

            if (messageErrorTimbrature.length === 0) {
                actions.push(notifsActions.notifSuccess(`Giustificativi avvenuti correttamente n.${resp.length} su n.${resp.length} individui`));
            } else if (messageErrorTimbrature.length === resp.length) {
                actions.push(notifsActions.notifError(messageErrorTimbrature));
            } else {
                actions.push(notifsActions.notifWarning(
                    `Timbrature di ${ENUM_TIMBRATURE[resp.filter(r => !r.isError)[0].tipo].azione.toLowerCase()} avvenute correttamente n.${resp.filter(r => !r.isError).length} su n.${resp.length} individui </br> 
                        ${messageErrorTimbrature.join('</br>')}`)
                );
            }

            actions.push(giustificativiActions.addGiustificativoEnd());

            return scheduled([
                ...actions,
                loadingOverlayActions.hideLoadingOverlay(),
                individuoActions.initIndividuiSelezionati()
            ], asyncScheduler);
        })
    );